import { render, staticRenderFns } from "./inma.vue?vue&type=template&id=b910ee0c&scoped=true&"
import script from "./inma.vue?vue&type=script&lang=js&"
export * from "./inma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b910ee0c",
  null
  
)

export default component.exports